import { z } from 'zod'

export const ADMINFORMSMODULESPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminFormsModulesPostResponseSchema = z.unknown()
export type AdminFormsModulesPostResponse = z.infer<typeof adminFormsModulesPostResponseSchema>
